export default __webpack_public_path__ + "static/img1-28a9c35df84698f20543ecaa3e3894f6.jpg";